import React from 'react';
import { SAccordionStacked } from '@avalara/skylab-sdk/react';
import { BlueHeading } from './accordion-styled-components';
const Accordion = ({ children, show, onToggle, title, isBlueHeading = false, }) => (React.createElement(SAccordionStacked, { open: show, "onS-toggle": onToggle },
    isBlueHeading
        ? React.createElement(BlueHeading, { slot: 'title', className: 'font-bold' }, title)
        : React.createElement("h2", { slot: 'title', className: 'alt' }, title),
    children));
export default Accordion;
